"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListItem = _interopRequireDefault(require("../List/ListItem"));
var _Table = require("material-ui/Table");
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));
var _close = _interopRequireDefault(require("material-ui/svg-icons/navigation/close"));
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _map2 = _interopRequireDefault(require("lodash/map"));
require("./MultiForm.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MultiForm = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiForm, _React$Component);
  var _super = _createSuper(MultiForm);
  function MultiForm(props) {
    var _this;
    _classCallCheck(this, MultiForm);
    _this = _super.call(this, props);
    _this.state = {
      rows: _this.props.list ? _this.props.list : []
    };
    _this.addNewAction = _this.addNewAction.bind(_assertThisInitialized(_this));
    _this.removeRowAction = _this.removeRowAction.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputChangeDebounced = (0, _debounce2["default"])(function (row, param, value) {
      this.handleInputChange.apply(this, [row, param, value]);
    }, 300);
    return _this;
  }
  _createClass(MultiForm, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.list !== nextProps.list) {
        this.setState({
          rows: nextProps.list
        });
      }
    }
  }, {
    key: "addNewAction",
    value: function addNewAction() {
      var currentRows = this.state.rows;
      var newEmptyRow = Object.assign({}, this.state.objectModel);
      currentRows.push(newEmptyRow);
      this.setState({
        rows: currentRows
      });
      if (typeof this.props.handleInputChange !== 'undefined') {
        this.props.handleInputChange(this.props.param, currentRows);
      }
    }
  }, {
    key: "removeRowAction",
    value: function removeRowAction(id) {
      console.log('removeRowAction', id);
      var currentRows = this.state.rows;
      currentRows.splice(id, 1);
      this.setState({
        rows: currentRows
      });
      if (typeof this.props.handleInputChange !== 'undefined') {
        this.props.handleInputChange(this.props.param, currentRows);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var objectModelTemplate = {};
      (0, _map2["default"])(this.props.options, function (optionForm) {
        objectModelTemplate[optionForm.param] = null;
      });
      var objectModel = Object.assign({}, objectModelTemplate);
      this.setState({
        objectModel: objectModel
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(row, param, value) {
      var parsedRow = parseInt(row);
      var rows = this.state.rows;
      if (this.props.injectLanguage) {
        var altRows = rows;
        altRows[parsedRow] = _objectSpread(_objectSpread({}, this.state.rows[parsedRow]), {}, _defineProperty({}, param, _defineProperty({}, this.props.language, value)));
        if (typeof this.props.handleInputChange !== 'undefined') {
          this.props.handleInputChange(this.props.param, altRows);
        }
      } else {
        rows[parsedRow] = _objectSpread(_objectSpread({}, this.state.rows[parsedRow]), {}, _defineProperty({}, param, value));
        if (typeof this.props.handleInputChange !== 'undefined') {
          this.props.handleInputChange(this.props.param, rows);
        }
      }
      this.setState({
        rows: rows
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var counter = 1;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "multiform-container"
      }, this.props.label ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "label-container"
      }, this.props.label) : null, this.state.rows ? /*#__PURE__*/_react["default"].createElement(_Table.Table, {
        className: "mf-table",
        wrapperStyle: {
          height: 'auto',
          overflow: 'visible'
        },
        selectable: false
      }, /*#__PURE__*/_react["default"].createElement(_Table.TableBody, {
        displayRowCheckbox: false
      }, (0, _map2["default"])(this.state.rows, function (rowData, key) {
        var parsedKey = parseInt(key);
        if (isNaN(parsedKey)) return;
        return /*#__PURE__*/_react["default"].createElement(_Table.TableRow, {
          className: "multiform-row",
          key: key
        }, /*#__PURE__*/_react["default"].createElement(_Table.TableRowColumn, {
          className: "mf-column",
          style: _defineProperty({
            width: 23,
            paddingRight: 0
          }, "paddingRight", 15)
        }, parsedKey + 1, "."), (0, _map2["default"])(_this2.props.options, function (form) {
          return /*#__PURE__*/_react["default"].createElement(_Table.TableRowColumn, {
            className: "mf-column ".concat(form.param),
            key: form.param
          }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
            handleInputChange: function handleInputChange(a, b) {
              form.type === 'assetEditor' ? undefined : _this2.handleInputChangeDebounced(key, a, b);
            },
            row: key,
            handleAddClick: form.type === 'assetEditor' ? _this2.props.handleAddClick : undefined,
            handleDeleteClick: form.type === 'assetEditor' ? _this2.props.handleDeleteClick : undefined,
            handleEditClick: form.type === 'assetEditor' ? _this2.props.handleEditClick : undefined,
            data: _this2.state.rows[parsedKey][form.param],
            item: _objectSpread(_objectSpread({}, form), {}, {
              inlineLabel: true
            }),
            styleName: _this2.props.styleName
          }));
        }), /*#__PURE__*/_react["default"].createElement(_Table.TableRowColumn, {
          className: "mf-column",
          style: {
            width: 30
          }
        }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          onClick: function onClick() {
            return _this2.removeRowAction(parsedKey);
          }
        }, /*#__PURE__*/_react["default"].createElement(_close["default"], null))));
      }))) : null, /*#__PURE__*/_react["default"].createElement(_FlatButton["default"], {
        className: "add-new-label",
        label: this.props.addNewLabel,
        onClick: this.addNewAction,
        primary: true
      }));
    }
  }]);
  return MultiForm;
}(_react["default"].Component);
MultiForm.defaultProps = {
  addNewLabel: "Add Option"
};
MultiForm.propTypes = {
  options: _propTypes["default"].object,
  list: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  param: _propTypes["default"].string,
  addNewLabel: _propTypes["default"].string,
  styleName: _propTypes["default"].string,
  injectLanguage: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  handleInputChange: _propTypes["default"].func,
  handleEditClick: _propTypes["default"].func,
  handleAddClick: _propTypes["default"].func,
  handleDeleteClick: _propTypes["default"].func
};
var _default = MultiForm;
exports["default"] = _default;